import { render, staticRenderFns } from "./table.vue?vue&type=template&id=4d4fff19&scoped=true&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./table.vue?vue&type=style&index=1&id=4d4fff19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4fff19",
  null
  
)

export default component.exports